<template>
  <b-modal v-model="localShow" @hidden="$emit('cancel')" @ok.prevent="setOvertime">
    <b-form>
      <b-row>
        <b-col cols="6">
          <b-form-group>
            <span slot="label">Początek nadgodzin</span>

            <date-picker format="dd.MM.yyyy" inputClass="form-control" v-model="dateStart" :monday-first="true" :language="dpLanguage" />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group>
            <span slot="label">Koniec nadgodzin</span>

            <date-picker format="dd.MM.yyyy" inputClass="form-control" v-model="dateEnd" :monday-first="true" :language="dpLanguage" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <span slot="label">
            Nadgodziny &nbsp;
            <b-checkbox v-model="check.overtime" class="float-right"></b-checkbox>
          </span>
        </b-col>

        <b-col cols="6">
          <time-select v-if="localShow" :set="overtime" :disabled="!check.overtime" @time="setTime" />
        </b-col>
      </b-row>
    </b-form>

    <span slot="modal-cancel">Anuluj</span>

    <span slot="modal-ok">Zapisz</span>
  </b-modal>
</template>

<script>
import DatePicker from 'vuejs-datepicker';
import { pl } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

import TimeSelect from '@/components/TimeSelect.vue';
import { WorkdayResource } from '@/resources/workday.resource';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  components: { TimeSelect, DatePicker },
  data() {
    return {
      dpLanguage: pl,
      check: { overtime: false },
      localShow: false,
      overtime: '1:00',
      dateStart: '',
      dateEnd: ''
    };
  },
  methods: {
    setOvertime() {
      WorkdayResource.setOvertime(this.dateStart, this.dateEnd, parseInt(this.$route.params.id, 10), this.check.overtime, this.parseTime(this.overtime))
        .then(() => {
          this.close();
        })
        .catch(error => {
          this.$notify({ type: 'error', title: 'Błąd!', text: 'Niepoprawnie wypełniony formularz.' });
          console.warn(error);
        });
    },
    parseTime(time) {
      if (!time) {
        return 0;
      }
      const split = time.split(':').map(n => parseInt(n, 10));
      return split[0] * 60 + split[1];
    },
    close() {
      this.$emit('close');
    },
    setTime(value) {
      this.overtime = value;
    }
  },
  watch: {
    show(show) {
      this.localShow = show;
    }
  }
};
</script>
